import type { ReactNode } from 'react';
import { TimeZoneProvider } from '@/feature/timezone';
import { useFirstSelected } from '@/view/fleet/selection/SelectionContext';
import { useEquipmentTimeZone } from './useEquipmentTimeZone';

export const EquipmentTimeZoneProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const equipmentId = useFirstSelected();
  const { timeZone } = useEquipmentTimeZone(equipmentId);
  return <TimeZoneProvider timeZone={timeZone}>{children}</TimeZoneProvider>;
};
